import React from "react";
import FeatureSoon from "../components/redesign/FeatureSoon";

const Soon = () => {
  return <FeatureSoon />;
};

export default Soon;
